import React, { useEffect, useRef, useState } from "react";
import { API, getSession } from "../lib/vikas";

export function WhatChanged({ autoOpen = false, onClose }) {
  const [open, setOpen] = useState(autoOpen);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  const run = async () => {
    setOpen(true);
    setBusy(true);
    setFailed(false);
    setText("");
    try {
      const s = getSession();
      const res = await fetch(`${API}/what-changed`, {
        method: "POST",
        headers: { Authorization: `Bearer ${s?.token || ""}` },
      });
      if (!res.ok || !res.body) throw new Error("failed");
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let acc = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        acc += decoder.decode(value, { stream: true });
        setText(acc);
      }
      if (!acc.trim()) setFailed(true);
    } catch {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (autoOpen && !started.current) {
      started.current = true;
      run();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpen]);

  const close = () => {
    setOpen(false);
    setText("");
    setFailed(false);
    if (onClose) onClose();
  };

  return (
    <>
      {!autoOpen && (
        <button className="vk-btn" data-testid="what-changed-btn" onClick={run} disabled={busy}>
          {busy ? "Reading…" : "What changed"}
        </button>
      )}
      {open && (
        <div className="panel w-full mt-1" data-testid="what-changed-box" style={{ borderColor: "var(--accent)" }}>
          <div className="flex items-start justify-between gap-3 mb-2">
            <span className="lbl" data-testid="what-changed-label" style={{ color: "var(--accent)" }}>
              Built from the data file — check the row
            </span>
            <button className="vk-arrow" data-testid="what-changed-close" onClick={close} aria-label="close">
              ✕
            </button>
          </div>
          {failed ? (
            <div className="nm text-sm" data-testid="what-changed-error">No summary — try again later</div>
          ) : (
            <div className="text-sm" data-testid="what-changed-text" style={{ whiteSpace: "pre-wrap" }}>
              {text || (busy ? "…" : "")}
            </div>
          )}
        </div>
      )}
    </>
  );
}
